import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "app2" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "加载中", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "main",
  "element-loading-text": "全力加载中..."
}
const _hoisted_6 = { class: "trees" }
const _hoisted_7 = { class: "treesHead" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-folder-open" }, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-code-o" }, null, -1)
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "treesItem"
}
const _hoisted_14 = { class: "contentTrees" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "bottomMenu" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-up" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "body" }
const _hoisted_20 = { class: "editor" }
const _hoisted_21 = { class: "editorMenu" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = { class: "dialog-footer" }

import { ref, onMounted, reactive, watch } from "vue";
import axios from "axios";
import { Base64 } from "js-base64";
import MarkdownIt from "markdown-it";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import themeUtil from "@/utils/themeUtil";
import hljs from "highlight.js";
import Clipboard from "clipboard";
import {
    Share,
    Edit,
    ArrowLeft,
    ArrowRight,
    Sunny,
    UploadFilled,
    User,
    Setting,
    Search
} from "@element-plus/icons-vue";
import * as monaco from "monaco-editor";
import { ElMessage } from "element-plus";
import type { FormInstance } from "element-plus";

// 添加请求拦截器

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

axios.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        loadContent.value = true;
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        loadContent.value = false;
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        // 2xx 范围内的状态码都会触发该函数。
        // 对响应数据做点什么
        loadContent.value = false;
        return response.data;
    },
    function (error) {
        // 超出 2xx 范围的状态码都会触发该函数。
        // 对响应错误做点什么
        loadContent.value = false;
        return Promise.resolve(error.response);
    }
);

onMounted(() => {
    themeUtil.load();

    init();

    // 根据屏幕宽度决定菜单收缩状态
    screenWidthMenuState();
    // 屏幕宽度发生变化
    window.onresize = () => {
        screenWidthMenuState();
    };
});

const md = new MarkdownIt();

const config = reactive({
    // Gitee 配置
    gitee: {
        // 账号
        owner: "n0ts",
        // 仓库名称
        repo: "note",
        // 分支名
        sha: "master"
    },
    // 后端地址
    serverBase: "https://api.n0ts.top",
    // 主题配置
    Themes: ["default-light", "default-dark"]
});

// 仓库下的所有文件
const Trees = ref<any>(null);
// 当前内容
const content = ref("");
// 当前选择的文件
const contentSelectIndex = ref<number>(-1);
// 菜单默认选择
const treeMenu = ref("文件");
// 笔记加载遮罩
const loadContent = ref(false);
// 文章目录数据
const menuData = ref<any>(null);
// 当前目录选择索引
const menuSelectIndex = ref(0);
// 菜单是否展开
const menuShow = ref(true);
// 计算屏幕长度，防抖
const timeOut = ref();
// 计算内容滚动距离，防抖
const timeOut2 = ref();
// 子文件夹路径
const childFile = ref();
// 图片集
const ViewerUtil = ref();
// 内容页内边高度
const contentPaddingTop = ref(0);
// 当前 markdown 内容
const markdown = ref("");
// 是否启用编辑
const editorState = ref(false);
// 文章内容 Dom
const contentDom = ref();

/**
 * 加载主题
 */
function loadTheme() {
    themeUtil.switchTheme();
    myEditor.updateOptions({
        theme: getMonacoTheme()
    });
}

/**
 * 初始化
 */
async function init() {
    const params = getQueryParams();
    if (params.path && params.owner && params.repo && params.sha) {
        config.gitee = {
            owner: params.owner,
            repo: params.repo,
            sha: params.sha
        };
    } else {
        await initLogin();
    }

    await getTrees();
    initMonaco();
}

// 登陆状态
const loginState = ref(false);
/**
 * 是否需要登录加载数据
 */
async function initLogin() {
    const test = getUserInfo();
    if (test) {
        const userData = await getGiteeData();
        if (userData) {
            loginState.value = true;
            config.gitee = userData["eazy-note"];
        }
    }
}

/**
 * 获取缓存用户信息
 */
function getUserInfo() {
    let userLogin: any = window.localStorage.getItem("n0ts-note-user");
    if (userLogin) {
        userLogin = JSON.parse(userLogin);
        loginData.username = userLogin.username;
        loginData.password = userLogin.password;
        return userLogin;
    } else {
        return null;
    }
}

// tree 数据备份，用于搜索
let treeBackup: any[] = [];

/**
 * 获取目录 Tree
 */
async function getTrees() {
    const body: any = {
        method: "GET",
        url: `/repos/${config.gitee.owner}/${config.gitee.repo}/git/trees/${config.gitee.sha}?recursive=1`
    };

    // 如果登陆，携带上账号密码
    if (loginState.value) {
        body.username = loginData.username;
        body.password = loginData.password;
    }

    const resData: any = await axios.post(
        config.serverBase + "/api/gitee/proxy",
        body
    );

    if (resData.status && resData.status != 200) {
        if (loginState.value) configDialog.value = true;
        ElMessage.warning(resData.msg);
        return;
    }

    Trees.value = resData;
    console.log("🚀 树数据 | Trees.value:", Trees.value);

    // 数据验证
    if (!Trees.value.tree) {
        content.value = `## 仓库是空的？\n快去检查吧！`;
        // 设置内容
        return setContent();
    }

    // 数据过滤，保留 md 后缀的文件
    let readme = null;
    Trees.value.tree = Trees.value.tree
        .map((item: any) => {
            // README 放第一
            if (item.path == "README.md") {
                readme = item;
                return null;
            }
            if (
                item.path.substring(item.path.length - 3, item.path.length) ==
                ".md"
            ) {
                return item;
            }
        })
        .filter(Boolean);
    if (readme) Trees.value.tree.unshift(readme);

    if (Trees.value.tree.length == 0) {
        return (content.value = "<h2>这里空空如也～</h2><p>快去写点东西吧</p>");
    }

    // 保存 tree 数据
    treeBackup = JSON.parse(JSON.stringify(Trees.value.tree));

    // 获取仓库具体路径下的内容
    const querys = getQueryParams();
    if (querys.path) {
        getContents(querys.path);
    } else if (readme) {
        getContents("README.md");
    } else {
        getContents(Trees.value.tree[0].path);
    }
}

// 文件数搜索关键词
const treeSearchText = ref("");
let treeSearchTimeout: number | undefined;
watch(
    () => treeSearchText.value,
    () => {
        if (treeSearchTimeout) {
            clearTimeout(treeSearchTimeout);
        }
        treeSearchTimeout = setTimeout(() => {
            if (!treeSearchText.value) {
                Trees.value.tree = treeBackup;
                return refreshPathIndex();
            }

            let cache: any;
            Trees.value.tree = treeBackup
                .map((tree: any) => {
                    cache = JSON.parse(JSON.stringify(tree));
                    const index = cache.path
                        .toUpperCase()
                        .indexOf(treeSearchText.value.toUpperCase());
                    if (index != -1) {
                        const key = cache.path.substring(
                            index,
                            index + treeSearchText.value.length
                        );
                        cache.lighthigh = cache.path.replace(
                            key,
                            `<span style="color: red;">${key}</span>`
                        );
                        return cache;
                    }
                })
                .filter(Boolean);
            refreshPathIndex();
        }, 100);
    }
);

// 当前文件路径
const currentPath = ref("");

/**
 * 根据当前文件路径定位索引
 */
function refreshPathIndex() {
    for (let i = 0; i < Trees.value.tree.length; i++) {
        if (Trees.value.tree[i].path == currentPath.value) {
            contentSelectIndex.value = i;
            return;
        }
    }
    contentSelectIndex.value = -1;
}

/**
 * 获取仓库具体路径下的内容
 * @param {*} path 文件名
 * @returns 文件数据
 */
async function getContents(path: string, index?: number) {
    console.log("当前获取文件路径", path);

    // 索引修改 & 是否重复
    if (contentSelectIndex.value == index) {
        return;
    }

    currentPath.value = path;

    if (index != null) {
        contentSelectIndex.value = index;
    } else {
        refreshPathIndex();
    }

    // 数据验证
    if (!path) {
        return;
    }

    // 子文件夹路径获取
    childFile.value = path.includes("/")
        ? path.substring(0, path.lastIndexOf("/"))
        : "";

    const body: any = {
        method: "GET",
        url:
            `/repos/${config.gitee.owner}/${config.gitee.repo}/contents/` +
            encodeURIComponent(path)
    };

    // 如果登陆，携带上账号密码
    if (loginState.value) {
        body.username = loginData.username;
        body.password = loginData.password;
    }

    const res: any = await axios.post(
        config.serverBase + "/api/gitee/proxy",
        body
    );
    Trees.value.tree[contentSelectIndex.value].sha = res.sha;

    // 存储 markdown 格式
    markdown.value = content.value = Base64.decode(res.content);

    // 是否存在内容
    if (!content.value || content.value.trim() == "") {
        content.value = `## 这里空空如也～\n没写点东西还好意思上传？`;
    }

    // 设置内容
    setContent();

    // 滚动条回到顶部
    backTop(0);
}

/**
 * 设置内容
 */
function setContent() {
    // md 保存到 编辑器
    editContent.value = content.value;

    // 转换为 html，超链接新建页面打开
    markdownRender(content.value);

    setTimeout(() => {
        // 获取文章目录
        getContentMenu();

        // 文章内图片查看加载
        loadImgView();

        // 监听内容区滚动条
        listenContentScroll();

        // 编辑器初始化
        initMonaco();
    }, 0);
}

/**
 * markdown 内容渲染
 * @param {string} data markdown
 */
function markdownRender(data: string) {
    content.value = md.render(data).replace(/<a /g, "<a target='_blank' ");

    // 转换后是否为空
    if (!content.value || content.value.trim() == "") {
        content.value =
            "<h2>这里空空如也～</h2><p>没写点东西还好意思上传？</p>";
    }

    // 获取内容中全部图片的 src
    content.value.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
        (match, capture) => {
            // 是否为 url
            let testVol =
                // eslint-disable-next-line
                /^(http|https):\/\/(([\w-]+\.)+[\w-]+|localhost)(\/[\w-.\/?%&=]*)?$/.test(
                    capture
                );

            // 不是 url 则添加仓库链接
            if (!testVol) {
                const url = `https://gitee.com/${config.gitee.owner}/${config.gitee.repo}/raw/${config.gitee.sha}${childFile.value}/${capture}`;
                let replacement = `https://api.n0ts.top/api/gitee/img?url=${encodeURIComponent(
                    url
                )}`;
                content.value = content.value.replace(capture, replacement);
            }

            return match;
        }
    );

    setTimeout(() => {
        // 索引复原
        menuSelectIndex.value = 0;

        // 代码高亮
        hljsInit();
    }, 0);
}

/**
 * 代码高亮
 */
async function hljsInit() {
    const dom: any = [];
    const codeBlocks = document.querySelectorAll("#content pre code");
    codeBlocks.forEach((cache) => {
        const item = cache as HTMLElement;
        if (item.getAttribute("class")?.includes("hljs")) {
            return;
        }
        const copyBtn = document.createElement("div");
        copyBtn.className = "copyBtn";
        copyBtn.innerHTML = "复制";
        copyBtn.setAttribute("code", item.innerText);
        copyBtn.addEventListener("click", (e) => {
            copyCode(e);
        });
        item.parentElement?.appendChild(copyBtn);
        hljs.highlightElement(item as HTMLElement);
        dom.push(item);
    });
    addCodeNum(dom);
}

/**
 * 添加代码行号
 */
function addCodeNum(dom: any) {
    for (let i = 0; i < dom.length; i++) {
        const enter = dom[i].innerHTML.replace(/\n/g, "</li><li>");
        dom[i].innerHTML = `<ol><li>${enter}</li></ol>`.replace(
            "<li></li></ol>",
            "</ol>"
        );
    }
}

/**
 * 复制代码块
 */
function copyCode(el: MouseEvent) {
    const code = (el.target as HTMLElement).getAttribute("code");
    if (code) {
        Clipboard.copy(code);
    }
    ElMessage.success("复制成功");
}

/**
 * 获取文章目录
 */
function getContentMenu() {
    menuData.value = null;
    let dom = contentDom.value.querySelectorAll("h1, h2, h3, h4");
    menuData.value = [...dom].map((item) => {
        // 获取标签名，内容，距离顶边高度
        let { tagName, textContent, offsetTop } = item;
        return {
            tagName,
            textContent,
            offsetTop
        };
    });
}

/**
 * 文章内图片查看加载
 */
function loadImgView() {
    if (!ViewerUtil.value) {
        return (ViewerUtil.value = new Viewer(
            document.querySelector("#content") as HTMLElement
        ));
    }
    ViewerUtil.value.update();
}

/**
 * 监听内容区滚动条
 */
function listenContentScroll() {
    contentDom.value.addEventListener("scroll", (e: any) => {
        if (timeOut2.value) {
            clearTimeout(timeOut2.value);
        }
        timeOut2.value = setTimeout(() => {
            // 计算高度增加一丢丢
            let top = e.target.scrollTop + 30;

            // 实时获取标题元素
            let dom = contentDom.value.querySelectorAll("h1, h2, h3, h4");
            let trees = [...dom].map((item) => {
                return item.offsetTop;
            });

            // 第一个标题高度处理
            let oneTitle = window.getComputedStyle(dom[0]).marginTop;
            oneTitle = Number(
                oneTitle.substring(0, oneTitle.length - 2)
            ).toString();
            if ((trees[0] - contentPaddingTop.value).toString() == oneTitle) {
                trees[0] = 0;
            }

            // 遍历判断当前高度对应标题位置
            for (let i = 0; i < trees.length; i++) {
                // 当滚动高度大于对应索引改变高亮
                if (top >= trees[i]) {
                    menuSelectIndex.value = i;
                }
            }
        }, 50);
    });
}

/**
 * 滚动条到指定位置
 */
function backTop(top: number) {
    if (!contentDom.value) {
        contentDom.value = document.querySelector("#content");
    }
    contentDom.value.scrollTo({
        top,
        behavior: "smooth"
    });
}

/**
 * 目录选择
 * @param {*} i 索引
 */
function menuSelect(i: number) {
    // 设置索引高亮
    menuSelectIndex.value = i;

    // 获取滚动高度
    let top = contentDom.value.querySelectorAll("h1, h2, h3, h4")[i].offsetTop;

    contentDom.value.scrollTo({
        top,
        behavior: "smooth"
    });
}

/**
 * 菜单展开与隐藏
 */
function menuShowOrHide() {
    menuShow.value = !menuShow.value;
}

/**
 * 根据屏幕宽度决定菜单收缩状态
 * 用于动态自适应
 */
function screenWidthMenuState() {
    if (timeOut.value) {
        clearTimeout(timeOut.value);
    }
    let state = document.body.clientWidth <= 820;
    timeOut.value = setTimeout(() => {
        // 当屏幕小于820 且 菜单是打开的情况下
        if (state && menuShow.value) {
            menuShowOrHide();
        }
    }, 100);
}

/**
 * 编辑框保存到码云
 */
async function saveEdit() {
    if (!loginState.value) {
        return ElMessage.warning("请登录后再进行保存");
    }

    // md.replace(
    //     // eslint-disable-next-line no-useless-escape
    //     /(http|https):\/\/(([\w-]+\.)+[\w-]+|localhost)(\/[\w-.\/?%&=]*)/gi,
    //     (match, capture) => {
    //         if (
    //             match.indexOf("https://api.n0ts.top/api/gitee/img?url=") == -1
    //         ) {
    //             return match;
    //         }

    //         const giteeUrl = decodeURIComponent(
    //             match.replace("https://api.n0ts.top/api/gitee/img?url=", "")
    //         );
    //         console.log(giteeUrl);

    //         return match;
    //     }
    // );

    const file = Trees.value.tree[contentSelectIndex.value];

    const data = await axios.post(config.serverBase + "/api/gitee/proxy", {
        username: loginData.username,
        password: loginData.password,
        method: "PUT",
        url: `/repos/${config.gitee.owner}/${config.gitee.repo}/contents/${file.path}`,
        data: {
            content: Base64.encode(myEditor.getValue()),
            sha: file.sha,
            message: `更新了 ${file.path}`
        }
    });
    if (data.status == 400)
        return ElMessage.warning("没有权限，请检查是否为自己仓库");

    await getContents(file.path);
    openMonaco();
    ElMessage.success("更新成功");
}

/**
 * 获取 url 的 query
 */
function getQueryParams() {
    let queryString = window.location.href;
    let params: any = {};

    if (!queryString) {
        return params;
    }

    // 去除开头的问号字符
    queryString = queryString.split("?")[1];
    if (!queryString) return {};

    let paramList = queryString.split("&");
    for (let i = 0; i < paramList.length; i++) {
        let param = paramList[i].split("=");
        let paramName = decodeURIComponent(param[0]);
        let paramValue = decodeURIComponent(param[1] || "");
        // 将参数名和值保存到对象中
        if (paramName) {
            params[paramName] = paramValue;
        }
    }

    return params;
}

/**
 * 分享此笔记
 */
function shareNote() {
    Clipboard.copy(
        !Trees.value.tree[contentSelectIndex.value]
            ? `${window.location.origin}?owner=${config.gitee.owner}&repo=${config.gitee.repo}&sha=${config.gitee.sha}`
            : `${window.location.origin}?path=${
                  Trees.value.tree[contentSelectIndex.value].path
              }&owner=${config.gitee.owner}&repo=${config.gitee.repo}&sha=${
                  config.gitee.sha
              }`
    );

    ElMessage.success("已复制到剪贴板");
}

// 编辑器
let myEditor: monaco.editor.IStandaloneCodeEditor;
// 编辑器内容
const editContent = ref("");
// 编辑器 Dom
const monacoDom = ref();

/**
 * 初始化编辑器，如果存在则覆盖内容
 */
function initMonaco() {
    monacoDom.value = document.getElementById("container");
    if (monacoDom.value && !myEditor) {
        myEditor = monaco.editor.create(monacoDom.value, {
            value: editContent.value,
            language: "markdown",
            automaticLayout: true,
            theme: getMonacoTheme(),
            cursorSmoothCaretAnimation: "on",
            fontLigatures: true, // 启用字体连字
            fontSize: 16, // 字体大小
            fontFamily: "'Fira Code', 'Consolas', 'Courier New', monospace", // 字体名称
            fontWeight: "normal" // 字体粗细
        });

        // 编辑器按键按下触发事件
        let timeOutLock: any = null;
        myEditor.onKeyDown(() => {
            if (timeOutLock) clearTimeout(timeOutLock);
            timeOutLock = setTimeout(() => {
                markdownRender(myEditor.getValue());
            }, 500);
        });
    } else {
        myEditor.setValue(editContent.value);
    }
}

/**
 * 获取编辑器当前主题内容
 */
function getMonacoTheme() {
    const cache = window.localStorage.getItem("n0ts-note-theme");
    return cache == "light" ? "vs" : "vs-dark";
}

/**
 * 打开或关闭编辑器
 */
function openMonaco() {
    // 切换编辑状态
    editorState.value = !editorState.value;
    // 根据编辑状态切换侧边栏展示状态
    // menuShow.value = !editorState.value;
}

// 是否开启编辑器预览
// const monacoPreview = ref(true);

// 网页设置是否打开
const configDialog = ref(false);

// 网页设置规则
const configRuleFormRef = ref<FormInstance>();
const configRules = reactive({
    gitee: {
        owner: [
            {
                required: true,
                message: "请填写 Gitee 账号",
                trigger: "change"
            }
        ],
        repo: [
            {
                required: true,
                message: "请填写 Gitee 仓库名",
                trigger: "change"
            }
        ],
        sha: [
            {
                required: true,
                message: "请填写 Gitee 仓库分支",
                trigger: "change"
            }
        ]
    }
});

// 登陆窗口是否打开
const loginDialog = ref(false);
// 登陆数据
const loginData = reactive({
    username: "",
    password: "",
    token: ""
});
// 网页设置规则
const loginRuleFormRef = ref<FormInstance>();
const loginRules = reactive({
    username: [
        {
            required: true,
            message: "请填写账号",
            trigger: "change"
        }
    ],
    password: [
        {
            required: true,
            message: "请填写密码",
            trigger: "change"
        }
    ]
});

/**
 * 登陆或注册 Gitee Token
 */
function login(formEl: FormInstance | undefined) {
    if (!formEl) return;
    formEl.validate(async (valid) => {
        if (!valid) return;
        giteeDataSave();
    });
}

/**
 * 获取 Gitee Token 数据
 */
async function getGiteeData() {
    const data = await axios.post(config.serverBase + "/api/gitee/data", {
        username: loginData.username,
        password: loginData.password
    });
    if (data.status != 200) {
        console.log("账号已失效，请重新登录", data);
        // window.localStorage.removeItem("n0ts-note-user");
        ElMessage.warning("账号已失效，请重新登录");
        return null;
    }
    return data.data;
}

/**
 * 保存数据到 Gitee Token
 */
async function giteeDataSave(formEl?: FormInstance | null) {
    async function save() {
        const postData = JSON.parse(JSON.stringify(loginData));
        if (!postData.token) {
            delete postData.token;
        }

        // 有 token 或登录状态下携带数据
        if (postData.token || loginState.value) {
            postData.jsonData = {
                "eazy-note": null
            };
            postData.jsonData["eazy-note"] = config.gitee;
        }

        const data: any = await axios.post(
            config.serverBase + "/api/gitee/data",
            postData
        );
        if (data.status != 200) {
            return ElMessage.warning(data.msg);
        }

        window.localStorage.setItem(
            "n0ts-note-user",
            JSON.stringify({
                username: loginData.username,
                password: loginData.password
            })
        );

        configDialog.value = false;
        loginDialog.value = false;

        // 没有 token 且没登录则提示
        if (!postData.token && !loginState.value) {
            ElMessage.success("登陆成功！");
        } else {
            ElMessage.success("保存成功！");
        }

        // 没登录则进行登陆
        if (!loginState.value) {
            await initLogin();
        }

        getTrees();

        giteeURL.value = "";
    }

    if (!formEl) return await save();

    formEl.validate(async (valid) => {
        if (!valid) return;
        await save();
    });
}

/**
 * 退出登录
 */
function logout() {
    window.localStorage.clear();
    ElMessage.success("已退出登录，准备刷新");
    setTimeout(() => {
        window.location.reload();
    }, 1500);
}

// 分析配置 url
const giteeURL = ref("");
watch(
    () => giteeURL.value,
    () => {
        const data = giteeURL.value.split("/").splice(3);
        if (data.length == 2) {
            config.gitee.owner = data[0];
            config.gitee.repo = data[1];
        }
    }
);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!Trees.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass({ leftMenu: true, leftMenuHide: menuShow.value })
            }, [
              _createVNode(_component_el_tabs, {
                modelValue: treeMenu.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((treeMenu).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "文件",
                    name: "文件"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: treeSearchText.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((treeSearchText).value = $event)),
                        placeholder: "搜一下下？",
                        "prefix-icon": _unref(Search),
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (treeSearchText.value = ''), ["esc"])),
                        class: "treeSearch",
                        size: "small"
                      }, null, 8, ["modelValue", "prefix-icon"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("a", {
                            href: Trees.value.giteeURL,
                            target: "_blank"
                          }, [
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(Trees.value.sha), 1)
                          ], 8, _hoisted_8)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Trees.value.tree, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass({
                                    treesItem: true,
                                    treesItemActive: index == contentSelectIndex.value
                                }),
                            onClick: ($event: any) => (getContents(item.path, index)),
                            key: index
                          }, [
                            _hoisted_11,
                            _createElementVNode("span", {
                              innerHTML: item.lighthigh ?? item.path
                            }, null, 8, _hoisted_12)
                          ], 10, _hoisted_10))
                        }), 128)),
                        (Trees.value.tree.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 暂无数据哦 "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "目录",
                    name: "目录"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass({
                                    contentItem: true,
                                    contentItemActive: index == menuSelectIndex.value,
                                    [item.tagName]: true
                                }),
                            key: index,
                            onClick: ($event: any) => (menuSelect(index))
                          }, _toDisplayString(item.textContent), 11, _hoisted_15))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  content: "回到顶部",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (backTop(0)))
                }, _hoisted_18),
                (menuShow.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      content: "收起菜单",
                      onClick: menuShowOrHide
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowLeft))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      content: "展开菜单",
                      onClick: menuShowOrHide
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowRight))
                        ]),
                        _: 1
                      })
                    ])),
                _createElementVNode("div", {
                  content: "更换主题",
                  onClick: loadTheme
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Sunny))
                    ]),
                    _: 1
                  })
                ]),
                (loginState.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      content: "编辑笔记",
                      onClick: openMonaco
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Edit))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  content: "分享此笔记",
                  onClick: shareNote
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Share))
                    ]),
                    _: 1
                  })
                ]),
                (!loginState.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      content: "登陆",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (loginDialog.value = true))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(User))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      content: "配置",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (configDialog.value = true))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Setting))
                        ]),
                        _: 1
                      })
                    ]))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ peBlack: true, peBlackHide: menuShow.value }),
              onClick: menuShowOrHide
            }, null, 2),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", { onClick: saveEdit }, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "保存到 Gitee",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(UploadFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_22
              ]),
              _createElementVNode("div", {
                class: _normalizeClass({ content: true, contentHiddent: editorState.value }),
                id: "content",
                style: _normalizeStyle('padding-top:' + contentPaddingTop.value + 'px;')
              }, [
                _createElementVNode("div", { innerHTML: content.value }, null, 8, _hoisted_23)
              ], 6)
            ])
          ])), [
            [_directive_loading, loadContent.value]
          ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: loginDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((loginDialog).value = $event)),
      title: "登陆 或 注册",
      width: "320px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (login(loginRuleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 登陆 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": "top",
          "label-width": "150px",
          model: loginData,
          rules: loginRules,
          ref_key: "loginRuleFormRef",
          ref: loginRuleFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "账号",
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginData.username,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((loginData.username) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginData.password,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((loginData.password) = $event)),
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Gitee Access Token",
              prop: "token"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginData.token,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((loginData.token) = $event)),
                  placeholder: "注册需填写"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: configDialog.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((configDialog).value = $event)),
      title: "设置",
      width: "320px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_25, [
          _createVNode(_component_el_popconfirm, {
            title: "确定要退出登录吗？",
            onConfirm: logout
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { type: "danger" }, {
                default: _withCtx(() => [
                  _createTextVNode("退出登录")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (giteeDataSave(configRuleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "configRuleFormRef",
          ref: configRuleFormRef,
          "label-width": "135px",
          model: config,
          rules: configRules,
          prop: "config",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "仓库地址自动分析" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: giteeURL.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((giteeURL).value = $event)),
                  placeholder: "填入仓库地址自动分析"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Gitee 账号",
              prop: "gitee.owner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: config.gitee.owner,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((config.gitee.owner) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Gitee 仓库名",
              prop: "gitee.repo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: config.gitee.repo,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((config.gitee.repo) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Gitee 仓库分支",
              prop: "gitee.sha"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: config.gitee.sha,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((config.gitee.sha) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})